import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PredictiveCase from '../../interfaces/predictiveCase';

interface PredictiveCaseState {
    predictiveCases: PredictiveCase[],
}

const initialState: PredictiveCaseState = {
    predictiveCases: []
}

export const predictiveCaseSlice = createSlice({
    name: 'predictiveCases',
    initialState,
    reducers: {
        loadPredictiveCases: (state, action: PayloadAction<PredictiveCase[]>) => {
            state.predictiveCases = action.payload
        },
        removePredictiveCase: (state, action: PayloadAction<string>) => {
            // Remove the PredictiveCase with matching case_id
            state.predictiveCases = state.predictiveCases.filter(
                (pc) => pc.case_id !== action.payload
            );
        },
        removePredictiveCaseNumber: (
            state,
            action: PayloadAction<{ case_id: string; number: string }>
        ) => {
            // Remove the number from the numbers array of the matching PredictiveCase
            const updated = state.predictiveCases.map((pc) => {
                if (pc.case_id === action.payload.case_id) {
                    return {
                        ...pc,
                        numbers: pc.numbers.filter(
                        (num) => num !== action.payload.number
                        ),
                    };
                }
                return pc;
            });
            // Remove any cases whose numbers array is now empty
            state.predictiveCases = updated.filter((pc) => pc.numbers.length > 0);
        },
    }
});

export const {
  loadPredictiveCases,
  removePredictiveCase,
  removePredictiveCaseNumber,
} = predictiveCaseSlice.actions;

export default predictiveCaseSlice.reducer;

// Selector to get up to N predictive cases for a given client name.
export const selectPredictiveCasesByClientName = (
    allCases: PredictiveCase[],
    clientName: string,
    n: number
): PredictiveCase[] => {
    const filtered = allCases.filter((pc) => pc.case.client_name === clientName);
    return filtered.slice(0, n);
};